import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import { useParams } from "react-router-dom";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
export default function ProductDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [cartData, setCartData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [productData, setProductData] = useState([]);
    const [colorData, setColorData] = useState([]);
    const [selectedAge, setSelectedAge] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedMrp, setSelectedMrp] = useState(0);
    const [selectedPrice, setSelectedPrice] = useState(0);
    const [selectedQty, setSelectedQty] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [mainImage, setMainImage] = useState();
    const [variantId, setVariantId] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);
    useEffect(() => {
        fetchProductData();
        fetchCategoryData();
        fetchCartData();
    }, []);
    const fetchCategoryData = async () => {
        setLoading(true);
        try {
            const [color] = await Promise.all([
                makeRequest("get", webEndPoint + "productAttributes/product/" + id),
            ]);
            setColorData(color?.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (id) {
            fetchProductData();
        }
    }, [id]);
    const fetchProductData = async () => {
        if (!id) return;
        setLoading(true);
        try {
            let url = webEndPoint + "product/" + id;
            const response = await makeRequest("get", url);
            if (response) {
                setProductData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const increaseQty = () => {
        if (!variantId) { toast.error("Please Select the Product Size or Age"); return; }
        if (quantity < selectedQty) {
            setQuantity((prev) => prev + 1);
        } else {
            toast.error(`Maximum available quantity is ${selectedQty}`);
        }
    };
    const decreaseQty = () => {
        if (!variantId) { toast.error("Please Select the Product Size or Age"); return; }
        if (quantity > 1) setQuantity(prev => prev - 1);
    };
    const handleShare = async () => {
        const shareData = {
            title: productData.product_name,
            text: "Check out this product!",
            url: window.location.href
        }
        try {
            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                await navigator.clipboard.writeText(window.location.href);
                alert("Link copied to clipboard!");
            }
        } catch (err) {
            console.log("Share failed:", err);
        }
    };
    const filteredVariants = colorData?.filter(
        item => item.color_id === selectedColor
    );
    const ageData = filteredVariants?.filter(
        item => item.age_id !== null
    );
    const sizeData = filteredVariants?.filter(
        item => item.size_id !== null
    );
    const uniqueAges = Object.values(
        (ageData || []).reduce((acc, item) => {
            acc[item.age_id] = item;
            return acc;
        }, {})
    );
    const uniqueSizes = Object.values(
        (sizeData || []).reduce((acc, item) => {
            acc[item.size_id] = item;
            return acc;
        }, {})
    );
    useEffect(() => {
        if (uniqueColors?.length > 0) {
            setSelectedColor(uniqueColors[0].color_id);
            setMainImage(uniqueColors[0].color_image_url);
        }
    }, [colorData]);
    // const uniqueColors = Object.values(
    //     (colorData || []).reduce((acc, item) => {
    //         if (!acc[item.color_id]) {
    //             acc[item.color_id] = item;
    //         }
    //         return acc;
    //     }, {})
    // );
    const uniqueColors = Object.values(
        (colorData || [])
            .filter(item => Number(item.retail_quantity) > 0) // Only colors with stock
            .reduce((acc, item) => {
                if (!acc[item.color_id]) {
                    acc[item.color_id] = item;
                }
                return acc;
            }, {})
    );
    const handleAddToCart = async () => {
        const token = localStorage.getItem("userToken");
        if (!token) { navigate("/signin"); return; }
        if (!variantId) { toast.error("Please Select the Product Size or Age"); return; }
        if (!selectedQty) { toast.error("Currently Out of Stock."); return; }
        const existingCartItem = cartData?.items?.find(
            item => Number(item.variant_id) === Number(variantId)
        );
        const alreadyInCart = existingCartItem
            ? Number(existingCartItem.quantity)
            : 0;
        const totalRequiredQty = alreadyInCart + quantity;
        if (totalRequiredQty > selectedQty) {
            toast.error(`Only ${selectedQty} items available. Already ${alreadyInCart} in cart.`
            );
            return;
        }
        const cartItemData = {
            user_id: localStorage.getItem("userID"),
            product_id: id,
            variant_id: variantId,
            quantity: quantity,
            price: selectedPrice
        }
        try {
            setLoading(true);
            let url = webEndPoint + "cart/add";
            const response = await makeRequest("post", url, cartItemData);
            if (response) {
                setLoading(false);
                window.dispatchEvent(new Event("cartUpdated"));
                setQuantity(1);
                toast.success("Add to Card successfully!");
                fetchCartData();
            }
        } catch (err) {
            if (err?.message) {
                toast.error(err.message);
            } else {
                toast.error(err.message || "Something went wrong");
            }
        } finally {
            setLoading(false);
        }
    }
    const fetchCartData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "cart/" + localStorage.getItem("userID");
            const response = await makeRequest("get", url);
            if (response) {
                setCartData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const subtotal = cartData?.items?.reduce(
        (acc, item) => acc + Number(item.price) * item.quantity,
        0
    ) || 0;
    return (
        <div className="page-container">
            <Loader loading={loading} />
            <Header />
            <Breadcrumb />
            <div className="product-container">
                {/* <div className="image-section">
                    <img src={mainImage ? mainImage : colorData[0]?.color_image_url} alt="product" className="main-image" />
                    <div className="thumbnail-row">
                        {uniqueColors?.map((item) => (
                            <img key={item.rfId} src={item.color_image_url} alt={item.color_name} className={`thumb-img ${selectedColor === item.color_id ? "active-thumb" : ""}`}
                                onClick={() => {
                                    setMainImage(item.color_image_url);
                                    setSelectedColor(item.color_id);
                                    setSelectedAge(null);
                                    setSelectedSize(null);
                                    setSelectedPrice(0);
                                    setSelectedMrp(0);
                                    setVariantId(null);
                                    setSelectedQty(0);
                                }} />
                        ))}
                    </div>
                </div> */}
                {uniqueColors.length > 0 && (
                    <div className="image-section">
                        <img src={mainImage || uniqueColors[0].color_image_url} alt="product" className="main-image" />
                        {/* <div className="thumbnail-row">
                            {uniqueColors.map(item => (
                                <img key={item.rfId} src={item.color_image_url} alt={item.color_name} className={`thumb-img ${selectedColor === item.color_id ? "active-thumb" : ""}`}
                                    onClick={() => {
                                        setMainImage(item.color_image_url);
                                        setSelectedColor(item.color_id);
                                        setSelectedAge(null);
                                        setSelectedSize(null);
                                        setSelectedPrice(0);
                                        setSelectedMrp(0);
                                        setVariantId(null);
                                        setSelectedQty(0);
                                    }}
                                />
                            ))}
                        </div> */}
                        <div className="thumbnail-row">
                            {uniqueColors.map(item => (
                                <img
                                    key={item.rfId}
                                    src={item.color_image_url}
                                    alt={item.color_name}
                                    className={`thumb-img ${selectedColor === item.color_id ? "active-thumb" : ""
                                        }`}
                                    onClick={() => {
                                        setMainImage(item.color_image_url);
                                        setSelectedColor(item.color_id);
                                        setSelectedAge(null);
                                        setSelectedSize(null);
                                        setSelectedPrice(0);
                                        setSelectedMrp(0);
                                        setVariantId(null);
                                        setSelectedQty(0);
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                )}
                {uniqueColors.length > 0 ? (
                    <div className="details-section">
                        <h2>{productData.product_name}</h2>
                        <p className="brand">Brand: {productData.brand_name}</p>
                        <p className="category">{productData.maincategory_name}</p>
                        <div className="price-section">
                            {selectedPrice > 0 && <span className="price">₹{selectedPrice}</span>}
                            {selectedMrp > 0 && <span className="mrp">₹{selectedMrp}</span>}
                            {selectedPrice > 0 && <span className="availableQty"> Available Quantity - {selectedQty}</span>}
                        </div>
                        {uniqueAges.length > 0 && (
                            <div className="options">
                                <h4>Select Age</h4>
                                {/* {uniqueAges.map((item) => (
                                <button
                                    key={item.age_id}
                                    className={selectedAge === item.age_id ? "active" : ""}
                                    onClick={() => {
                                        setSelectedAge(item.age_id);
                                        setSelectedPrice(item?.agesalesprice);
                                        setSelectedMrp(item?.agemrp);
                                        setSelectedQty(item?.retail_quantity);
                                        setSelectedSize(null);
                                        setVariantId(item.rfId);
                                    }}>{item.age_name}</button>
                            ))} */}
                                {uniqueAges
                                    ?.filter(item => parseInt(item.retail_quantity || 0, 10) > 0)
                                    .map((item) => (
                                        <button
                                            key={item.age_id}
                                            className={selectedAge === item.age_id ? "active" : ""}
                                            onClick={() => {
                                                setSelectedAge(item.age_id);
                                                setSelectedPrice(item?.agesalesprice);
                                                setSelectedMrp(item?.agemrp);
                                                setSelectedQty(item?.retail_quantity);
                                                setSelectedSize(null);
                                                setVariantId(item.rfId);
                                            }}
                                        >
                                            {item.age_name}
                                        </button>
                                    ))
                                }
                            </div>
                        )}
                        {/* {uniqueSizes.length > 0 && (
                            <div className="options">
                                <h4>Select Size</h4>
                                {uniqueSizes.map((item) => (
                                    <button
                                        key={item.size_id}
                                        className={selectedSize === item.size_id ? "active" : ""}
                                        onClick={() => {
                                            setSelectedSize(item.size_id);
                                            setSelectedPrice(item?.sizesalesprice);
                                            setSelectedMrp(item?.sizemrp);
                                            setSelectedQty(item?.retail_quantity);
                                            setVariantId(item.rfId);
                                        }}>{item.size_name}</button>
                                ))}
                            </div>
                        )} */}

                        {uniqueSizes.filter(
                            (item) => Number(item.retail_quantity) > 0
                        ).length > 0 && (
                                <div className="options">
                                    <h4>Select Size</h4>

                                    {uniqueSizes
                                        .filter(
                                            (item) => Number(item.retail_quantity) > 0
                                        )
                                        .map((item) => (
                                            <button
                                                key={item.size_id}
                                                className={
                                                    selectedSize === item.size_id
                                                        ? "active"
                                                        : ""
                                                }
                                                onClick={() => {
                                                    setSelectedSize(item.size_id);
                                                    setSelectedPrice(item.sizesalesprice);
                                                    setSelectedMrp(item.sizemrp);
                                                    setSelectedQty(Number(item.retail_quantity));
                                                    setVariantId(item.rfId);
                                                    setQuantity(1);
                                                }}
                                            >
                                                {item.size_name}
                                            </button>
                                        ))}
                                </div>
                            )}

                        <div className="option-group">
                            <h4>Quantity</h4>
                            <div className="quantity-box">
                                <button onClick={decreaseQty}>-</button>
                                <span>{quantity}</span>
                                <button onClick={increaseQty}>+</button>
                            </div>
                        </div>
                        <div className="description">
                            <h4>Description</h4>
                            <p>{productData.product_description}</p>
                        </div>
                        <div className="size-guide-modal">
                            <img src={productData?.product_guide_image} alt="Size Guide" className="size-guide-image" />
                        </div>
                        <div className="action-buttons">
                            <button className="add-to-cart" onClick={handleAddToCart}>Add to Cart</button>
                            <button className="share-btn" onClick={handleShare}>Share</button>
                        </div>
                    </div>
                ) : (
                    <div className="details-section text-center">
                        <h3>Out of Stock</h3>
                        <p>This product is currently unavailable.</p>
                    </div>
                )}
            </div>
            <div className="track-order-float">Cart Amount : ₹ {subtotal}</div>
            <Footer />
        </div>
    )
}